import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    saving: false,
    error: null,
    respStatus: null,
};

export const fetchLaunches = createAsyncThunk(
    "launch/fetchLaunches",
    async (body = {}, { rejectWithValue }) => {
        try {
            const response = await instance.get(
                `/fraction/launch/fetch-all-launches?page=${body.page || 1}&search=${encodeURIComponent(body.search || "")}&property_id=${body.property_id || ""}`
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error?.message);
        }
    }
);

export const createLaunch = createAsyncThunk(
    "launch/createLaunch",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.post(
                "/fraction/launch/create-launch",
                JSON.stringify(body),
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error?.message);
        }
    }
);

export const updateLaunch = createAsyncThunk(
    "launch/updateLaunch",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.post(
                `/fraction/launch/update-launch?id=${body.id}`,
                JSON.stringify(body.data),
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error?.message);
        }
    }
);

export const deleteLaunch = createAsyncThunk(
    "launch/deleteLaunch",
    async (id, { rejectWithValue }) => {
        try {
            const response = await instance.delete(
                `/fraction/launch/delete-launch?id=${id}`
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error?.message);
        }
    }
);

const LaunchSlice = createSlice({
    name: "LaunchSlice",
    initialState,
    reducers: {
        clearLaunchResponse: (state) => {
            state.respStatus = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLaunches.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLaunches.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchLaunches.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        [createLaunch, updateLaunch, deleteLaunch].forEach((action) => {
            builder
                .addCase(action.pending, (state) => {
                    state.saving = true;
                    state.respStatus = null;
                    state.error = null;
                })
                .addCase(action.fulfilled, (state, actionResult) => {
                    state.saving = false;
                    state.respStatus = actionResult.payload;
                })
                .addCase(action.rejected, (state, actionResult) => {
                    state.saving = false;
                    state.error = actionResult.payload;
                });
        });
    },
});

export const { clearLaunchResponse } = LaunchSlice.actions;
export default LaunchSlice.reducer;
